<!-- =========================================================================================
  File Name: FormWizardValidation.vue
  Description: Form wizard with validation
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full mt-5">
          <h6 class="mb-2">Tipo de Orçamento</h6>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full mt-5">
          <ul class="demo-alignment">
            <li>
              <vs-radio
                color="success"
                v-model="orderType"
                vs-value="Equipamento Revenda"
                >Equipamento Revenda</vs-radio
              >
            </li>
            <li>
              <vs-radio
                color="#9ACD32"
                v-model="orderType"
                vs-value="Equipamento Venda Direta"
                >Equipamento Venda Direta</vs-radio
              >
            </li>
            <li>
              <vs-radio
                color="#1E90FF"
                v-model="orderType"
                vs-value="Suprimentos"
                name="orderType"
                v-validate="'required'"
                >Suprimentos</vs-radio
              >
            </li>
            <li>
              <vs-radio
                color="#1E90FF"
                v-model="orderType"
                vs-value="Mídias"
                name="orderType"
                >Mídias</vs-radio
              >
            </li>
            <!--<li>
              <vs-radio color="danger" v-model="orderType" vs-value="Peças"
                >Peças</vs-radio
              >
            </li>
            <li>
              <vs-radio
                color="warning"
                v-model="orderType"
                vs-value="Mão de Obra"
                >Mão de Obra</vs-radio
              >
            </li>-->
          </ul>
        </div>
      </div>
    </vx-card>
    <br />
    <Equipment
      v-if="
        orderType === 'Equipamento Revenda' ||
        orderType === 'Equipamento Venda Direta'
      "
      :orderTypeProps="orderType"
    />
    <br />
    <Supplies
      v-if="orderType === 'Suprimentos' || orderType === 'Mídias'"
      :orderTypeProps="orderType"
    />
    <br>
    <NewParts v-if="orderType === 'Peças'" :orderTypeProps="orderType" />
     <br>
    <NewLabor v-if="orderType === 'Mão de Obra'" :orderTypeProps="orderType" />
  </div>
</template>



<script>
import Equipment from "./Equipment";
import NewParts from "./NewParts";
import Supplies from "./Supplies";
import NewLabor from "./NewLabor";
import TableProducts from "../orderProducts/component/EditTable.vue";
import AddNewCustomer from "../customers/AddNewCustomer";
import IsDefaulter from "../IsDefaulter/Index.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import { momentJS, numberJS } from "@/helpers";
import { Validator } from "vee-validate";
import router from "@/router";
const dict = {
  custom: {
    customer: {
      required: "Selecione o cliente",
    },
    user: {
      required: "Selecione o Consultor",
    },
    personName: {
      required: "Digite o nome do Responsável",
    },
  },
};

Validator.localize("en", dict);
export default {
  components: {
    "v-select": vSelect,
    AddNewCustomer,
    TableProducts,
    Datepicker,
    IsDefaulter,
    Equipment,
    Supplies,
    NewParts,
    NewLabor
  },
  computed: {},
  data() {
    return {
      orderType: "Equipamento Revenda",
    };
  },
  methods: {},

  async created() {},
};
</script>
